const DISH_REVIEW_TASK_SORTING_CRITERIA = {
  MODIFIED_DATE: 'MODIFIED_DATE',
  MENU_SCRAPED_DATE: 'MENU_SCRAPED_DATE',
}

export default DISH_REVIEW_TASK_SORTING_CRITERIA
